import { render } from "./GeneralJournal.vue?vue&type=template&id=505c2aaf&scoped=true&ts=true"
import script from "./GeneralJournal.vue?vue&type=script&lang=ts"
export * from "./GeneralJournal.vue?vue&type=script&lang=ts"

import "./GeneralJournal.vue?vue&type=style&index=0&id=505c2aaf&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505c2aaf"]])

export default __exports__